import React, { useEffect, useState } from 'react';
import QuestionContainer from './QuestionContainer';
import FormButtonFM from './FormButtonFM';
import { handleParagraphOcr } from '../../../../features/ocr/helper-functions';
import InvoiceUpload from '../../../../features/ocr/invoiceUpload/InvoiceUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateAnalyzingImage,
  updateDocCounter,
  updateFlowCurrentStep,
  updateInitialTableDetails,
  updateTableDetails,
  updateTDProcessed,
  updateUploadValues,
  uploadImages,
} from '../../../../config/actions';
import { Box, Tooltip, TextField } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate, useSearchParams } from 'react-router-dom';
import heic2any from 'heic2any';
import useTranslations from '../../../../hooks/useTranslations';
import ModalMissingOCR from '../../../../features/claims/modals/ModalMissingOCR';
import { FLOW_TYPES, MISSING_OCR_TYPES } from '../../../../constants/Flow';
import { useTranslation } from 'react-i18next';
import { FMConstants } from '../../../../constants/Forms';
import useCompleteFlow from '../../../../hooks/useCompleteFlow';
import Exclamation from '../../../../assets/iconsSmall/exclamation_mark_white.svg';
import { isMobileOnly } from 'react-device-detect';
import { projectSettings } from '../../../../config/setting';
import { showToast } from '../../../../config/helpers';
import PandaMain from '../../../../assets/logos_main/PandaMain.png';

const defaultOcr = {
  picture: [],
  inProgress: false,
  step: 0,
  manual: [],
  ocr: {},
  tables: [],
  details: {},
};

export default function Upload({
  data,
  details,
  showButtons = true,
  width,
  updateClaim,
}) {
  const { t } = useTranslation();
  const router = useNavigate();
  const [currentMissingCounter, setCurrentMissingCounter] = useState(0);
  const [forRenderCounter, setForRenderCounter] = useState(0);
  const [missingTypes, setMissingTypes] = useState([]);
  const [duplicatesList, setDuplicatesList] = useState('');
  const [duplicatesListClaimNumber, setDuplicatesListClaimNumber] =
    useState('');

  const [openModalMissingOCR, setOpenModalMissingOCR] = useState(false);
  const [groupsList, setGroupsList] = useState([]);
  const [skipDiagChip, setSkipDiagChip] = useState(false);


  // 'comment' or 'upload'
  const [currentStep, setCurrentStep] = useState('comment');
  const [customerComment, setCustomerComment] = useState('');

  const flowStep = useSelector((s) => s.flow.flowCurrentStep);
  const currentPetInfo = useSelector((s) => s.flow.selectedPetInfo);
  const flowQuestions = useSelector((s) => s.flow.flowQuestions);
  const flowType = useSelector((s) => s.flow.flowType);
  const existingTypeDocument = useSelector((s) => s.flow.existingTypeDocument);
  const skipComment = flowType === FLOW_TYPES['Existing Claim'] && existingTypeDocument !== 'Subsequent invoice';

  const dispatch = useDispatch();
  const [ocrDetails, setOcrDetails] = useState(defaultOcr);
  const [searchParams] = useSearchParams();
  const [disableUpload, setDisableUpload] = useState(false); // Changed to false for comment step
  const disableComment = !customerComment.length;
  const disable = currentStep === 'comment' ? disableComment : disableUpload;
  const { getTranslatedText } = useTranslations();

  const [picGroup, setPicGroup] = useState([]);
  const [history, setHistory] = useState([]);
  const [docCounter, setDocCounter] = useState(0);

  const { compleFlow } = useCompleteFlow();

  async function onDrop(pictures) {
    let isFileList = false;
    let picture = pictures;
    if (pictures instanceof FileList) {
      isFileList = true;
      picture = Array.from(pictures);
    }

    const newHistory = picture.map((pic, index1) => {
      const foundPic = history.find((prevPic, index2) => {
        return (
          (prevPic.file.name === pic.name &&
            prevPic.file.size === pic.size &&
            index1 === index2 &&
            prevPic.isDeleted === true) ||
          (prevPic.file.name === pic.name &&
            prevPic.file.size === pic.size &&
            index1 !== index2 &&
            prevPic.isDeleted === false)
        );
      });
      if (foundPic) {
        return { file: pic, isDeleted: true };
        // return { file: pic, isDeleted: isFileList ? false : true };
      }
      return { file: pic, isDeleted: false };
    });

    if (isFileList) {
      setHistory((prev) => [...prev, ...newHistory]);
    } else {
      setHistory(newHistory);
    }

    const notDeletedPictures = newHistory
      .filter((obj) => obj.isDeleted === false)
      .map((obj) => obj.file);

    const files = await Promise.all(
      notDeletedPictures.map(async (file) => {
        if (file.name.toLowerCase().includes('.heic')) {
          const blob = await fetch(URL.createObjectURL(file)).then((r) =>
            r.blob()
          );
          try {
            const convertedBuffer = await heic2any({
              blob,
              toType: 'image/jpeg',
            });
            const convertedFile = new File(
              [convertedBuffer],
              `${file.name.replace(/\.heic$/i, '.jpg')}`,
              {
                type: 'image/jpeg',
              }
            );
            return convertedFile;
          } catch (error) {
            console.error('Error converting HEIC to JPEG:', error);
            if (file.name.toLowerCase().includes('.heic')) {
              const updatedTypeFile = new File([file], file.name, {
                type: 'image/heic',
              });
              return updatedTypeFile; // Return the original file in case of conversion error
            } else {
              return file;
            }
          }
        } else {
          return file;
        }
      })
    );

    setGroupsList([{ opened: true, picGroup: files }]);
    setOcrDetails({ ...ocrDetails, picture: files });

    setPicGroup(files);
    dispatch(uploadImages(files));

    setTimeout(() => {
      setDisableUpload(false);
    }, 100);
  }

  const onSetOcrDetails = (ocr) => {
    if (!ocr?.loading) {
      if (
        (ocr?.details?.Diagnosis || !projectSettings.diagCheck) &&
        (ocr?.details?.ChipNumber || !projectSettings.chipCheck) &&
        (ocr?.details?.DuplicateClaims?.content == '' ||
          !projectSettings.duplicatesCheck) &&
        (!ocr?.details?.ChipNumberMissed?.content || !projectSettings.chipCheck)
      ) {
        dispatch(updateFlowCurrentStep(flowStep + 1));
      } else {
        if (
          !ocr?.details?.Diagnosis &&
          projectSettings.diagCheck &&
          !skipDiagChip
        ) {
          setForRenderCounter((prev) => prev + 1);
          setMissingTypes((prev) => [...prev, MISSING_OCR_TYPES.diagnosis]);
        }
        if (
          ocr?.details?.ChipNumberMissed?.content &&
          projectSettings.chipCheck &&
          !skipDiagChip
        ) {
          setForRenderCounter((prev) => prev + 1);
          setMissingTypes((prev) => [
            ...prev,
            MISSING_OCR_TYPES.chipnumberNotFound,
          ]);
        }
        if (
          !ocr?.details?.ChipNumber &&
          !ocr?.details?.ChipNumberMissed?.content &&
          projectSettings.chipCheck &&
          !skipDiagChip
        ) {
          setForRenderCounter((prev) => prev + 1);
          setMissingTypes((prev) => [
            ...prev,
            MISSING_OCR_TYPES.chipnumberDoesNotMatch,
          ]);
        }
        if (
          ocr?.details?.DuplicateClaims?.content &&
          ocr?.details?.DuplicateClaims?.content.length &&
          projectSettings.duplicatesCheck
        ) {
          setDuplicatesList(
            ocr?.details?.DuplicateClaims?.content.map((claim) => claim.id)
          );
          setDuplicatesListClaimNumber(
            ocr?.details?.DuplicateClaimsNumber?.content
          );

          setForRenderCounter((prev) => prev + 1);
          setMissingTypes((prev) => [...prev, MISSING_OCR_TYPES.duplicates]);
        }
      }
    }

    setOcrDetails(ocr);
    dispatch(updateUploadValues({ [details.uniqueId]: ocr || defaultOcr }));
  };

  const onFinish = () => {
    setCurrentMissingCounter((prev) => prev + 1);
  };

  const errorHandler = () => {
    showToast(t('somethingWentWrong'), { error: true });
  };

  // Claims go straight to Nuclicore as a single merged file: no OCR / analyse-image call.
  // handleParagraphOcr only merges + uploads the files (noAnalyze) and returns the blob ids,
  // which are attached to the claim record; the flow then moves on.
  const handleInvoice = async () => {
    try {
      dispatch(updateAnalyzingImage(true));
      const result = await handleParagraphOcr({
        allPhotos: ocrDetails?.picture,
        ocrDetails,
        data,
        setOcrDetails: onSetOcrDetails,
        claim_id: searchParams.get('claimId'),
        noAnalyze: true,
        currentPetInfo,
        setDocCounter,
        errorHandler,
        customerComment,
        dispatch
      });
      await updateClaim({}, {
        picturesId: [...result.attachedFilesId],
        customerComment
      });
      dispatch(updateFlowCurrentStep(flowStep + 1));
    } catch (err) {
      console.error(err);
      errorHandler(err);
    } finally {
      dispatch(updateAnalyzingImage(false));
    }
  };

  // Handle next button click based on current step
  const handleNext = () => {
    if (currentStep === 'comment') {
      setCurrentStep('upload');
      setDisableUpload(true); // Disable next until files are uploaded

    } else {
      handleInvoice();
    }
  };

  // Handle back button click
  const handleBack = () => {
    if (currentStep === 'upload') {
      setCurrentStep('comment');
      setDisableUpload(false);
    } else {
      // Handle regular back navigation
      // You might want to call your existing back navigation logic here
    }
  };

  useEffect(() => {
    if (forRenderCounter > 0) {
      setOpenModalMissingOCR(true);
    }
  }, [forRenderCounter]);

  useEffect(() => {
    dispatch(updateDocCounter(docCounter));
  }, [docCounter]);

  useEffect(() => {
    if (
      flowType === FLOW_TYPES['Existing Claim'] &&
      existingTypeDocument !== 'Subsequent invoice'
    ) {
      setSkipDiagChip(true);
    } else {
      setSkipDiagChip(false);
    }
  }, [flowType, existingTypeDocument]);

  useEffect(() => {
    if (skipComment) {
      setCurrentStep('upload');
      setDisableUpload(true);
    }
  }, [skipComment]);

  useEffect(() => {
    if (currentMissingCounter === forRenderCounter) {
      setOpenModalMissingOCR(false);
      if (
        currentMissingCounter > 0 ||
        (currentMissingCounter === 0 &&
          Object.keys(ocrDetails.details).length > 0)
      ) {
        const isLastStep = flowStep === flowQuestions.length - 1;
        const isUploadOcr =
          flowQuestions[flowStep][0]?.type === FMConstants.UPLOAD &&
          flowQuestions[flowStep][0]?.content?.ocr;
        
        // Transform OCR details to tableDetails whenever on Upload step with OCR
        if (isUploadOcr) {
          if (ocrDetails.details && ocrDetails.details.Items && ocrDetails.details.Items.values) {
            let tableDetailsPrep = [];
            let basedOn = 'Amount';

            // Transforming data into tableDetails
            for (let i = 0; i < ocrDetails.details.Items.values.length; i++) {
              let tempRow = ocrDetails.details.Items.values[i].properties;

              tempRow['Pet'] = currentPetInfo.nameOfPet;
              const id = 'id' + Math.random().toString(16).slice(2);
              tempRow.IdToCompare = id;
              tempRow.IsNewLine = tempRow?.IsNewLine && !tempRow.hasOwnProperty('changedValues')
                ? tempRow?.IsNewLine
                : false;

              tempRow['Date'] = tempRow['Date']?.content || tempRow['Date'] || '';

              if (typeof tempRow['Description'] === 'object') {
                tempRow['Description'] = tempRow['Description']?.content;
              }

              if (ocrDetails.details.Items.values[i].properties['Quantity']) {
                if (typeof ocrDetails.details.Items.values[i].properties['Quantity'] === 'object') {
                  tempRow['Quantity'] = ocrDetails.details.Items.values[i].properties['Quantity']?.value;
                } else {
                  tempRow['Quantity'] = ocrDetails.details.Items.values[i].properties['Quantity'];
                }
              } else {
                tempRow['Quantity'] = 1;
              }

              if (ocrDetails.details.Items.values[i].properties['Amount']?.value?.currencySymbol) {
                tempRow['Currency'] = ocrDetails.details.Items.values[i].properties['Amount']?.value?.currencySymbol;
              } else {
                tempRow['Currency'] = null;
              }

              ['UnitPrice', 'Amount', 'Tax', 'TaxRate'].map((k) => {
                if (ocrDetails.details.Items.values[i].properties[k]) {
                  if (typeof ocrDetails.details.Items.values[i].properties[k] === 'object') {
                    tempRow[k === 'TaxRate' ? 'Tax' : k] = Number(
                      ocrDetails.details.Items.values[i].properties[k]?.value?.amount ||
                      ocrDetails.details.Items.values[i].properties[k]?.value
                    );
                  } else {
                    tempRow[k] = ocrDetails.details.Items.values[i].properties[k];
                  }
                } else {
                  tempRow[k] = 0;
                }
              });

              if (!tempRow.Tax) {
                tempRow.Tax = 19;
              }

              // If flag basedOn equals 'Amount' swap Amount to UnitPrice and recalculate Amount
              if (basedOn === 'Amount') {
                tempRow['UnitPrice'] = tempRow['Amount'];
                tempRow['Amount'] = Math.round(
                  tempRow['UnitPrice'] * (1 + tempRow['Tax'] / 100) * 100
                ) / 100;
              }

              // Calculate UnitPrice if missing or equals Amount
              if (!tempRow['UnitPrice'] || tempRow['UnitPrice'] == tempRow['Amount']) {
                tempRow['UnitPrice'] = Math.round(
                  (tempRow['Amount'] / (1 + tempRow.Tax / 100)) * 100
                ) / 100;
              }

              tableDetailsPrep.push(tempRow);
            }

              // Store tableDetails in Redux for subsequent flow steps
              dispatch(updateTableDetails(tableDetailsPrep));
              
              // If this is the last step, call compleFlow directly
              if (isLastStep) {
                compleFlow(null, tableDetailsPrep);
              } else {
                // Otherwise just move to next step
                dispatch(updateFlowCurrentStep(flowStep + 1));
              }
          } else {
            // No OCR items, move to next step or complete flow
            if (isLastStep) {
              compleFlow();
            } else {
              dispatch(updateFlowCurrentStep(flowStep + 1));
            }
          }
        } else {
          // Not an upload OCR step, just move to next step
          dispatch(updateFlowCurrentStep(flowStep + 1));
        }
      }
    }
  }, [currentMissingCounter, forRenderCounter, ocrDetails]);

  useEffect(() => {
    dispatch(updateTDProcessed(false));
    dispatch(updateTableDetails([]));
    dispatch(updateInitialTableDetails([]));
  }, []);

  return (
    <QuestionContainer width={width}>
      {openModalMissingOCR && (
        <ModalMissingOCR
          openModalMissingOCR={openModalMissingOCR}
          setOpenModalMissingOCR={setOpenModalMissingOCR}
          onFinish={onFinish}
          reportType={missingTypes[currentMissingCounter]}
          duplicatesList={duplicatesList}
          duplicatesListClaimNumber={duplicatesListClaimNumber}
        />
      )}
      {showButtons && (
        <Box style={{ width: '100%' }}>
          <Box className="flow-item-wrapper_less-margin">
            <Box className="flow-item-column">
              <div className="TitleQuestion flow-title-text flow-title-center">
                {currentStep === 'upload' ? t('upload') : t('customerComment')}
                {details.description && currentStep === 'upload' && (
                  <div className="TooltipGap">
                    <Tooltip
                      title={getTranslatedText(details.description)}
                      placement="right"
                    >
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  </div>
                )}
              </div>

              {/* Customer Comment Step */}
              {currentStep === 'comment' && (
                <div className="answers-container">
                  <img
                    src={PandaMain}
                    alt="Panda_Main_Logo"
                    className="main-logo-account"
                  />
                  <TextField
                    multiline
                    fullWidth
                    variant="outlined"
                    rows={12}
                    placeholder={t('enterCustomerComment') || 'Warum waren Sie beim Tierarzt?'}
                    value={customerComment}
                    onChange={(e) => setCustomerComment(e.target.value)}
                    sx={{
                      marginTop: '35px',
                      '& .MuiOutlinedInput-root': {
                        padding: '15px 35px',
                        background: '#FFFEFA',
                        border: '1px solid #E7E7E7',
                        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.65)',
                        borderRadius: '13px',
                        fontSize: '16px',
                        lineHeight: '1.5',
                        minHeight: 500,
                        alignItems: 'flex-start',
                        '& fieldset': {
                          border: 'none',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: 0,
                        resize: 'none',
                        '&::placeholder': {
                          fontFamily: 'RooneySans',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: '21px',
                          lineHeight: '26px',
                          color: '#A09F9D',
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </div>
              )}

              {/* Upload Step */}
              {currentStep === 'upload' && (
                <>
                  <div className="AnswersContainer AnswersContainerUpload">
                    <InvoiceUpload
                      onDrop={onDrop}
                      ocrDetails={ocrDetails}
                      setOcrDetails={setOcrDetails}
                      groupsList={groupsList}
                      setGroupsList={setGroupsList}
                      setDisableNext={setDisableUpload}
                      setPicGroup={setPicGroup}
                      picGroup={picGroup}
                      history={history}
                      setHistory={setHistory}
                    />
                  </div>
                  {((flowType !== FLOW_TYPES['Liability claim'] &&
                    flowType !== FLOW_TYPES['Existing Claim']) ||
                    (flowType === FLOW_TYPES['Existing Claim'] &&
                      existingTypeDocument === 'Subsequent invoice')) && (
                      <>
                        <div
                          className={`invoice-table-info ${isMobileOnly ? 'mobile' : ''
                            }`}
                          style={{ margin: '40px 0 10px 0' }}
                        >
                          <div>
                            <img src={Exclamation} alt="Info-image" />
                          </div>
                          <span>
                            {flowType === 'Cost estimation'
                              ? t('achtungChip_CE')
                              : t('achtungChip')}
                            {flowType === 'General to Vets' && (
                              <>
                                <br />
                                {t('achtungChip_GtV')}
                              </>
                            )}
                          </span>
                        </div>
                        {/* <div
                          className={`invoice-table-info ${isMobileOnly ? 'mobile' : ''
                            }`}
                          style={{ margin: '40px 0 10px 0' }}
                        >
                          <div>
                            <img src={Exclamation} alt="Info-image" />
                          </div>
                          <span style={{ padding: '12px' }}>
                            {t('uploadInvoiceLimit')}
                          </span>
                        </div> */}
                      </>
                    )}
                </>
              )}

              <div
                className="NavBtnsContainer"
                style={{ marginBottom: '20px' }}
              >
                <FormButtonFM
                  name="Back"
                  route={
                    currentStep === 'comment' || (currentStep === 'upload' && skipComment)
                      ? 'back'
                      : 'custom'
                  }
                  onUpdate={currentStep === 'upload' && !skipComment ? handleBack : undefined}
                />
                <FormButtonFM
                  name="Next"
                  route={currentStep === 'comment' ? 'custom' : 'next'}
                  onUpdate={handleNext}
                  disabled={disable}
                />
              </div>
            </Box>
          </Box>
        </Box>
      )}
    </QuestionContainer>
  );
}
